module.exports = __webpack_public_path__ + "static/media/user_icon_public_red.3f254da6.svg";